<template>
  <div class="toolbar text-center">

    <!-- <div class="toolbar-btn toolbar-like-btn blue-text" role="button" :aria-label="[isLiked ? 'Fjern fra favoritter' : 'Tilføj til favoritter']" @click="likeController" tabindex="0">
      <span :class="['material-icons', 'like-icon-i', [isLiked ? 'pink-text' : 'blue-text']]" aria-hidden="true">favorite_border</span><br>
      <strong>Favorit</strong>
    </div>

    <div class="toolbar-btn toolbar-add-to-group blue-text" role="button" :aria-label="[isInGroup ? 'Fjern fra samling' : 'Tilføj til samling']" @click="addItemToUserGroup" tabindex="0">
      <span :class="['material-icons', 'like-icon-i', [isInGroup ? 'pink-text' : 'blue-text']]" aria-hidden="true">playlist_add</span><br>
      <strong>Samling</strong>
    </div> -->

    <div class="toolbar-btn map-image-toggle-btn grey-text" role="button" aria-label="Stedet har intet billede tilgængeligt" v-if="noImage">
      <span>
        <span class="material-icons" aria-hidden="true">camera_alt</span><br>
        <strong>Vis billede</strong>
      </span>
    </div>

    <div class="toolbar-btn map-image-toggle-btn blue-text" role="button" @click="switchBetweenImageAndMap" tabindex="0" v-else>
      <span v-show="!showImages">
        <span class="material-icons" aria-hidden="true">camera_alt</span><br>
        <strong>Vis billede</strong>
      </span>
      <span v-show="showImages">
        <span class="material-icons" aria-hidden="true">pin_drop</span><br>
        <strong>Vis kort</strong>
      </span>
    </div>

    <div class="toolbar-btn blue-text share-btn" role="button" :aria-label="'Del '+name" @click="shareItem" tabindex="0">
      <span class="material-icons" aria-hidden="true">share</span><br>
      <strong>Del</strong>
    </div>

    <!--<router-link :to="{path: reportUrl}" :aria-label="'Tip os om fejl i '+name">
      <div class="toolbar-btn blue-text">
        <span class="material-icons" aria-hidden="true">report_problem</span><br>
        <strong>Tip os</strong>
      </div>
    </router-link>-->

    <div class="toolbar-btn blue-text" role="button" :aria-label="'Tip os om fejl i '+name" @click="reportError" tabindex="0">
      <span class="material-icons" aria-hidden="true">report_problem</span><br>
      <strong>Tip os</strong>
    </div>

  </div>
</template>

<script>
import Profile from '@/assets/profile/Profile.js'
import { EventBus } from '@/main.js'

export default {
  data() {
    return {
      isLiked: false,
      isInGroup: false,
      reportUrl: '',
      likeOptions: false,
    }
  },
  props: {
    type: {
      type: String,
      required: true
    },
    showImages: {
      type: Boolean,
      required: true
    },
    noImage: {},
    tagId: {},
    id: {},
    name: {},
    img: {}
  },
  updated() {
    this.createData();
  },
  created() {
    this.createData();
    EventBus.$on('updatedLikes', () => {
  		this.createData();
    });
  },
  methods: {
    createData() {
      //this.reportUrl = (this.type == 'place') ? '/contact/report/'+this.tagId+','+this.id+'/'+this.type : '/contact/report/'+this.id+'/'+this.type;
      this.reportUrl = (this.type == 'place') ? 'mailto:odenserundt@odense.dk?subject=Fejl i sted. ID: '+this.id : 'mailto:odenserundt@odense.dk?subject=Fejl i '+this.type+'. ID: '+this.id;
      if(Profile.loggedIn && Profile.userData != false) {
        this.isLiked = Profile.checkIfItemIsLiked(this.type, this.id);
        this.isInGroup = Profile.checkIfItemIsInUserGroup(this.type, this.id);
      }
    },
    likeController() {
      if(Profile.loggedIn) {
        this.likeOptions = (this.type == 'place') ? {type: this.type, id: this.id, name: this.name, tagId: this.tagId, img: this.img} : {type: this.type, id: this.id, name: this.name, img: this.img};
        var isLiked = Profile.checkIfItemIsLiked(this.type, this.id);
        if(!isLiked) {
          Profile.like(this.likeOptions);
          this.isLiked = true;
        }
        else if(isLiked) {
          var obj = {message: 'Vil du fjerne '+this.name+' fra dine favoritter?', cancelBtnText: 'Nej', btnText: 'Ja', callbackType: 'function', callback: this.unlikeDone};
          EventBus.$emit('openMessageBox', obj);
        }
      }
      else {
        this.$router.push('/login');
      }
    },
    unlikeDone() {
      Profile.unlike(this.type, this.id);
      this.isInGroup = Profile.checkIfItemIsInUserGroup(this.type, this.id);
      this.isLiked = false;
    },
    addItemToUserGroup() {
      if(Profile.loggedIn) {
        this.$emit('addItemToUserGroup');
      }
      else {
        this.$router.push('/login/explain');
      }
    },
    switchBetweenImageAndMap() {
      this.$emit('switchBetweenImageAndMap');
    },
    shareItem() {
      EventBus.$emit('openShareBox', {name: this.name, type: this.type, tagId: this.tagId, id: this.id });
    },
    reportError() {
      let text = '<p>Har du fundet en fejl på siden?<br> Kontakt os på <a href="'+this.reportUrl+'" target="_blank">odenserundt@odense.dk</a>, hvis det handler om fejl og mangler i oplysningerne på Odense Rundt.\
      Husk at skrive hvilken side det drejer sig om.<br><br>Handler det om fejl eller mangler på selve det, siden handler om, skal du tippe Odense kommune om det på <a href="https://www.odense.dk/givettip">odense.dk/givettip</a></p>';
      EventBus.$emit('openMessageBox', {message: text, btnText: 'Ok'});
    }
  },
}
</script>

<style lang="scss" scoped>
  .toolbar {
    position: relative;
    top: 0px;
    left: 0px;
    height: 56px;
    border-bottom: 1px solid #dedede;
  }

  .toolbar-btn {
    width: 20%;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
  }

  /*Portrait - XS*/
  @media screen and (max-width: 767px) and (orientation: portrait) {
    .toolbar-btn strong {
      font-size: 11px;
    }
  }

  .toolbar-btn .material-icons {
    position: relative;
    top: 5px;
    height: 30px;
    width: 30px;
    font-size: 20px;
  }
</style>
